// You can write more code here

/* START OF COMPILED CODE */

import DefaultConfirmButton_m from '../DefaultConfirmButton_m';
import DefaultButton from '../GeneralUI/Buttons/DefaultButton';
import DefaultDenyButton from '../GeneralUI/Buttons/DefaultDenyButton';
import DefaultDenyButton_m from '../GeneralUI/Buttons/DefaultDenyButton_m';
import UIBlocker from '../GeneralUI/UIBlocker';
/* START-USER-IMPORTS */
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import {
  getAnchorPlugin,
  waitForMilliseconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import Login from '@/game/scenes/Login/Login';
/* END-USER-IMPORTS */

export default class QuitToMenuModal extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(scene, 0, 0);
    this.add(uIBlocker);

    // desktopView
    const desktopView = scene.add.container(0, 0);
    desktopView.visible = false;
    this.add(desktopView);

    // mainContainer
    const mainContainer = scene.add.container(0, 0);
    desktopView.add(mainContainer);

    // backing
    const backing = scene.add.nineslice(
      0,
      0,
      'Hud1',
      undefined,
      114,
      64,
      10,
      10,
      10,
      10,
    );
    backing.scaleX = 4;
    backing.scaleY = 4;
    mainContainer.add(backing);

    // yesButton
    const yesButton = new DefaultButton(scene, -104, 72);
    mainContainer.add(yesButton);

    // taskLabel
    const taskLabel = scene.add.bitmapText(0, -40, 'Aronui', 'Are you sure?');
    taskLabel.setOrigin(0.5, 0.5);
    taskLabel.tintTopLeft = 5387071;
    taskLabel.tintTopRight = 5387071;
    taskLabel.tintBottomLeft = 5387071;
    taskLabel.tintBottomRight = 5387071;
    taskLabel.text = 'Are you sure?';
    taskLabel.fontSize = -14;
    mainContainer.add(taskLabel);

    // titleText
    const titleText = scene.add.bitmapText(0, -64, 'Aronui', 'Quit To Menu');
    titleText.setOrigin(0.5, 0.5);
    titleText.tintTopLeft = 985612;
    titleText.tintTopRight = 985612;
    titleText.tintBottomLeft = 985612;
    titleText.tintBottomRight = 985612;
    titleText.text = 'Quit To Menu';
    titleText.fontSize = -30;
    mainContainer.add(titleText);

    // noButton
    const noButton = new DefaultDenyButton(scene, 104, 72);
    mainContainer.add(noButton);

    // mobileView
    const mobileView = scene.add.container(0, 0);
    this.add(mobileView);

    // mainContainer_m
    const mainContainer_m = scene.add.container(0, 0);
    mobileView.add(mainContainer_m);

    // backing_m
    const backing_m = scene.add.nineslice(
      0,
      0,
      'Hud1',
      undefined,
      228,
      128,
      10,
      10,
      10,
      10,
    );
    backing_m.scaleX = 2;
    backing_m.scaleY = 2;
    mainContainer_m.add(backing_m);

    // taskLabel_m
    const taskLabel_m = scene.add.bitmapText(0, -40, 'Aronui', 'Are you sure?');
    taskLabel_m.setOrigin(0.5, 0.5);
    taskLabel_m.tintTopLeft = 5387071;
    taskLabel_m.tintTopRight = 5387071;
    taskLabel_m.tintBottomLeft = 5387071;
    taskLabel_m.tintBottomRight = 5387071;
    taskLabel_m.text = 'Are you sure?';
    taskLabel_m.fontSize = -14;
    mainContainer_m.add(taskLabel_m);

    // titleText_m
    const titleText_m = scene.add.bitmapText(0, -64, 'Aronui', 'Quit To Menu');
    titleText_m.setOrigin(0.5, 0.5);
    titleText_m.tintTopLeft = 985612;
    titleText_m.tintTopRight = 985612;
    titleText_m.tintBottomLeft = 985612;
    titleText_m.tintBottomRight = 985612;
    titleText_m.text = 'Quit To Menu';
    titleText_m.fontSize = -30;
    mainContainer_m.add(titleText_m);

    // yesButton_m
    const yesButton_m = new DefaultConfirmButton_m(scene, -104, 72);
    mainContainer_m.add(yesButton_m);

    // noButton_m
    const noButton_m = new DefaultDenyButton_m(scene, 104, 72);
    mainContainer_m.add(noButton_m);

    // yesButton (prefab fields)
    yesButton.buttonText = 'Yes';

    // noButton (prefab fields)
    noButton.buttonText = 'No';

    // yesButton_m (prefab fields)
    yesButton_m.buttonText = 'Yes';

    // noButton_m (prefab fields)
    noButton_m.buttonText = 'No';

    this.uIBlocker = uIBlocker;
    this.yesButton = yesButton;
    this.noButton = noButton;
    this.mainContainer = mainContainer;
    this.desktopView = desktopView;
    this.yesButton_m = yesButton_m;
    this.noButton_m = noButton_m;
    this.mainContainer_m = mainContainer_m;
    this.mobileView = mobileView;

    /* START-USER-CTR-CODE */

    this.getResponsiveElements('yesButton').forEach(
      (yesButton: DefaultButton | DefaultConfirmButton_m) => {
        yesButton.controller.setSubmissionCallback(() => {
          EventBus.emit(GAME_EVENTS.PLAYER_CONFIRMED_QUIT_MAIN_LEVEL);
          getSceneManager()?.launchScene('Login', Login, {
            type: 'gameplay',
            stopActiveScene: true,
          });
        });
      },
    );

    this.getResponsiveElements('noButton').forEach(
      (noButton: DefaultButton | DefaultConfirmButton_m) => {
        noButton.controller.setSubmissionCallback(() => {
          this.setVisible(false);
          PhaserAudioManager.playSFX(this.scene, 'panel-close');
        });
      },
    );

    this.initializeResponsiveness();

    /* END-USER-CTR-CODE */
  }

  private uIBlocker: UIBlocker;
  public yesButton: DefaultButton;
  public noButton: DefaultDenyButton;
  private mainContainer: Phaser.GameObjects.Container;
  private desktopView: Phaser.GameObjects.Container;
  public yesButton_m: DefaultConfirmButton_m;
  public noButton_m: DefaultDenyButton_m;
  private mainContainer_m: Phaser.GameObjects.Container;
  private mobileView: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  getResponsiveElements(key: keyof QuitToMenuModal) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  open() {
    PhaserAudioManager.playSFX(this.scene, 'npc_dialogue_open');
    this.initializeResponsiveness();
    this.setVisible(true);
  }

  async initializeResponsiveness() {
    if (!this.scene || !this.scene.scene.isActive()) return;
    await waitForMilliseconds(this.scene.time, 1);

    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });

    const anchor = getAnchorPlugin(this.scene);
    anchor.add(this.mainContainer, {
      centerX: '50%',
      centerY: '50%',
    });
    anchor.add(this.mainContainer_m, {
      centerX: '50%',
      centerY: '50%',
    });
    anchor.add(this, {
      left: '0%',
      top: '0%',
    });

    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.mainContainer, {
      ...DEFAULT_SCALE_DOWN_CONFIG,
      scaleModifier: 1.5,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
